import React, { createContext, useContext, useState } from 'react';

const InspectContext = createContext();

export const useInspect = () => {
  const context = useContext(InspectContext);
  if (!context) {
    throw new Error('useInspect must be used within an InspectProvider');
  }
  return context;
};

export const InspectProvider = ({ children }) => {
  const [inspectedMethodId, setInspectedMethodId] = useState(null);

  const toggleInspect = (methodId) => {
    setInspectedMethodId(inspectedMethodId === methodId ? null : methodId);
  };

  const clearInspect = () => {
    setInspectedMethodId(null);
  };

  const value = {
    inspectedMethodId,
    toggleInspect,
    clearInspect,
  };

  return (
    <InspectContext.Provider value={value}>{children}</InspectContext.Provider>
  );
};
